"use client";

import React from "react";
import { Card } from "./ui/card";
import forexSend from "../assets/images/forex/forexSend.svg";
import { Button } from "./ui/button";
import { Lock } from "lucide-react";

const SendForexComplete = ({ assetName, onDone }) => {
  const finalAssetName = assetName?.toUpperCase() || "Asset";

  return (
    <>
      <Card className="w-full bg-white rounded-2xl shadow-xl p-12 flex flex-col items-center text-center">
        <img
          src={forexSend}
          alt="Purchase Success"
          width={150}
          height={150}
          className="mb-6"
        />

        <h2 className="text-2xl font-bold text-purple-700 mb-4">
          {"You've sent"} {finalAssetName}
        </h2>
        <p className="text-lg font-normal text-gray-600 mb-10">
          Your recipient should receive the funds shortly.
        </p>

        <Button
          onClick={onDone}
          className="w-1/2 py-3 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold h-16"
        >
          Done
        </Button>

        <div className="flex items-center justify-center gap-1 text-sm text-gray-500 mt-6">
          <Lock size={12} />
          <p>Secured by 80Eight</p>
        </div>
      </Card>
    </>
  );
};

export default SendForexComplete;
